jQuery(document).ready(function ($) {
    $(document)
        .on('click', 'li.filter-category', function () {
            $('li.filter-category').removeClass('active')
            $(this).addClass('active')

            const scrollContainer = $('.grid-filter ul');
            const scrollLeft = $(this).offset().left - scrollContainer.offset().left + scrollContainer.scrollLeft();
            const scrollOffset = scrollLeft - (scrollContainer.width() / 2) + ($(this).outerWidth() / 2);

            $.ajax({
                url: wpajax.url,
                type: "POST",
                data: {
                    action: "gridFilterAjax",
                    catID: $(this).attr('data-id'),
                    gridCount: ($('.grid-section').hasClass('mobile') ? 3 : 6)
                },
                success: function (response) {
                    $('.grid-container').html(response);
                    scrollContainer.animate({scrollLeft: scrollOffset}, 255);
                }
            })
        })
        .on('click', 'button.load-more', function () {
            $.ajax({
                url: wpajax.url,
                type: "POST",
                data: {
                    action: "gridLoadmoreAjax",
                    catID: $('li.filter-category.active').attr('data-id'),
                    displayedPosts: $('.grid-section .grid-post-card').length,
                    gridCount: ($('.grid-section').hasClass('mobile') ? 3 : 6)
                },
                success: function (response) {
                    $('.grid-load-more').remove()
                    $('.grid-posts').append(response.output)
                    if(response.outputLoadmore) {
                        $('.grid-posts').after(response.outputLoadmore)
                    }

                }
            })
        })
        .on('click', '.hamburger', function () {
            $(this).toggleClass('active');
            $(this).siblings('.menu-header-menu-container').toggleClass('active');
            $(this).siblings('.header__logo').toggleClass('active');
        })
        /*.on('click', '.post-section__sidebar .post-section__sidebar-list a[href^="#"]', function (e) {
            const target = $(this.getAttribute('href'));
            if (target.length) {
                e.preventDefault();
                $('html, body').stop().animate({
                    scrollTop: target.offset().top
                }, 1000);
            }
        })*/


    if ($('.media-content__video').length) {
        const videos = document.querySelectorAll('.media-content__video');

        videos.forEach((item) => {
            const itemVideo = item.querySelector('video');
            const itemButton = item.querySelector('.media-content__video-play');

            if (itemVideo && itemButton) {
                const handleClick = () => {
                    if (itemVideo.paused) {
                        itemButton.classList.add('play');
                        itemVideo.play();
                    } else {
                        itemButton.classList.remove('play');
                        itemVideo.pause();
                    }
                };

                itemVideo.addEventListener('click', handleClick);
                itemButton.addEventListener('click', handleClick);
            }
        });
    }
    /*if ($('.post-section__sidebar').length) {
        $(window).on('scroll', function () {
            const scrollPos = $(window).scrollTop();
            $('.post-content .post-content-block').each(function () {
                const currSection = $(this);
                const refElement = currSection.attr('id');

                if (refElement) {
                    const sectionTop = currSection.offset().top;
                    const sectionBottom = sectionTop + currSection.outerHeight();

                    if (scrollPos >= sectionTop && scrollPos < sectionBottom) {
                        $(`a[href="#${refElement}"]`).addClass('active');
                    } else {
                        $(`a[href="#${refElement}"]`).removeClass('active');
                    }
                }
            });
        });
    }*/

})